// extracted by mini-css-extract-plugin
export var contentContainer = "styles-module__contentContainer___KThSV";
export var giftCards = "styles-module__giftCards___KVTmB";
export var heroContainer = "styles-module__heroContainer___qa0mk";
export var heroImage = "styles-module__heroImage___uZXZH";
export var heroMessage = "styles-module__heroMessage___wWP1g";
export var heroOverlay = "styles-module__heroOverlay___I8vFy";